import { createFileRoute } from "@tanstack/react-router";
import { AdminDatabasePage } from "@/components/admin/pages/AdminDatabasePage";

const DATABASE_TABS = new Set(["health", "urgent", "database", "apis", "links", "geo"]);
const HEALTH_SUB_TABS = new Set([
  "productionMonitoring",
  "infrastructure",
  "security",
  "housekeeping",
]);

export const Route = createFileRoute("/pulse-ops-x7k2/database")({
  validateSearch: (search: Record<string, unknown>) => {
    const tab = typeof search.tab === "string" && DATABASE_TABS.has(search.tab) ? search.tab : undefined;
    const healthSub =
      typeof search.healthSub === "string" && HEALTH_SUB_TABS.has(search.healthSub)
        ? search.healthSub
        : undefined;
    return { tab, healthSub };
  },
  component: AdminDatabasePage,
});
